export default __webpack_public_path__ + "static/media/3dcube.72e11080.svg";